

<div class="container" >

    <div [innerHTML]="privacy"></div>

</div>